import { MeApi } from 'src/api';
import { getPathSessionUrl, PathSessionUrlOptions } from 'src/utils/getPathSessionUrl';

/** Whether the learner has any words due for review in this language pair. */
export const hasWordsDueForReview = async (languagePairId: number): Promise<boolean> => {
  try {
    const practice = await MeApi.getPractice(languagePairId);
    return practice.review.enabled && practice.review.count > 0;
  } catch {
    return false;
  }
};

/**
 * Marks a session launched from a Review stone, so its start and completion
 * events show whether the learner reviewed or got Learn because nothing was due.
 */
export const PATH_REVIEW_STONE_QUERY = { key: 'path_stone', value: 'review' } as const;

/**
 * Resolves a path Review stone. A review with nothing due would be empty, so
 * the stone serves a Learn session instead; it keeps the same pathway node, so
 * finishing it still completes the Review stone and advances the path.
 */
export const getPathReviewSessionUrl = async (
  languagePairId: number,
  options: PathSessionUrlOptions,
): Promise<string> => {
  const sessionType = (await hasWordsDueForReview(languagePairId)) ? 'review' : 'vocab';
  const [pathname, query] = getPathSessionUrl(languagePairId, sessionType, options).split('?');
  const params = new URLSearchParams(query);
  params.set(PATH_REVIEW_STONE_QUERY.key, PATH_REVIEW_STONE_QUERY.value);
  params.sort();
  return `${pathname}?${params.toString()}`;
};
